<template>
    <div class="apply">
      <img
      src="../../assets/applyprocess/banner.png"
      alt
        style="width: 100%; height: 22.5rem ;overflow:hidden; object-fit: cover;"
    />
     <h3>{{msg}}</h3>
     <div class="container">
      <div class="line_div">
        <img
         class="line1"
          src="../../assets/applyprocess/line1_mobile.png"
          alt/>

         <img
         class="line2"
          src="../../assets/applyprocess/line2_mobile.png"
          alt/>

           <img
         class="line3"
          src="../../assets/applyprocess/line3_mobile.png"
          alt/>
        </div>

        <div style="width: 100%;">
         <div class="div_step" v-for="(item, index) in steps" :key="index" :style="{float:(index%2==0)?'left':'right',marginLeft:(index%2==0)?'5%':'0px',marginRight:(index%2==0)?'0px':'5%'}">
        <img
          :src="item.icon"
          alt
          style="width: 100%; height: 100%;"/>
        <span style="font-size:1.5rem;line-height: 2rem;color:#1A1A1A;font-weight: 600;text-align: center;display: block;
         margin-bottom: .9375rem;margin-top: 2.75rem;">{{ item.title }}</span>
        <!-- <div v-html="item.desc" style="font-size:1.5rem;line-height: 2rem;color: #777777;margin-bottom: 4.25rem;"></div> -->
        </div>
        </div>

     </div>
    </div>
</template>
<style scoped>
.apply{

min-height: 100%;
}
.container{
  position: relative;
  text-align: center;
  width: 100%;
  display: inline-block;
}
h3 {
  padding-top: 4.375rem;
  padding-bottom: 4.375rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;
}
.line_div{
  position: absolute;
  text-align: center;
  width:100%;
  height:100%;
  z-index: -1;
}
.div_step{
  width: 60%;
}
.line1{
position: absolute;
display:flex;
width: 32%;
top: 8%;
left: 52%;
}
.line2{
position: absolute;
display: inline-block;
width: 44%;
top: 29%;
left: 5%;
}

.line3{
position: absolute;
display: inline-block;
width: 43%;
top: 57%;
left: 42%;
}
</style>

<script>
export default {

    data () {
    return {
     msg: '应聘流程',
     steps:[
     {
       icon:require('../../assets/applyprocess/step01.png'),
       title:'简历投递',
       desc:'请登录专业招聘网站，<br/>选择相关职位投递简历。<br/>或者直接Email您的简历到<br/>job@yongxintechhk.com 投递意向职位。'
     },
     {
       icon:require('../../assets/applyprocess/step02.png'),
       title:'履历筛选',
       desc:'HR会与用人部门在综合考虑教育背景、<br/>工作经验、工作业绩、个人技能等初步筛选后，联系合适的候选人沟通安排面试。<br/>若目前没有合适职位空缺，HR会将您的简历放入内部人才库，如有合适职位时会再与您联系。'
     },
     {
       icon:require('../../assets/applyprocess/step03.png'),
       title:'面试',
       desc:'HR与用人部门会与您面谈，<br/>同时您可以更进一步了解公司的办公环境、工作内容及发展概况。<br/>HR会在面试后3个工作日左右以电话或<br/>邮件方式通知您进行下一步沟通。'
     },
     {
       icon:require('../../assets/applyprocess/step04.png'),
       title:'录用通知',
       desc:'双方就offer内容发成一致后，<br/>HR会在3天内通过邮件方式发放正式录用通知书。'
     }
     ],
     lines:[
        {
            icon:require('../../assets/applyprocess/line1_mobile.png'),
        },
        {
            icon:require('../../assets/applyprocess/line2_mobile.png'),
        },
        {
            icon:require('../../assets/applyprocess/line3_mobile.png'),
        },
     ]
    };
    },
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/ApplyProcess.vue